import { palette } from "@dev/ee-components";
import styled from "styled-components";

export const StepContentSeparator = styled.div`
    height: 1px;
    background-color: ${palette.gray[3]};
`;
